import { defineStore } from "pinia";
// import axios from "axios";
// import api from "@/api";
// import { API_BASE_URL } from "@/global-constants";
import { useMasterDataStore } from "@/stores/MasterDataStore";
export const useAgamaStore = defineStore("agamaStore", {
  state: () => ({
    data: null,
  }),
  onInit() {
    this.get();
  },
  persist: true,
  getters: {
    filter: (state) => (id) => {
      // return "hello, iam from filtering";
      return state.data.filter((g) => g.id === id);
    },
  },
  actions: {
    async get() {
      // if (!this.data) {
      //   try {
      //     const config = {
      //       headers: {
      //         Authorization: api.defaults.headers.common["Authorization"],
      //         "content-type": "application/json",
      //       },
      //     };
      //     const response = await axios.get( `${API_BASE_URL}/agama`,config);  // Replace with your API endpoint
      //     this.data = response.data;
      //   } catch (error) {
      //     console.error('agamaStore Error fetching:', error);
      //   }
      // }
      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.agama || [];
      }
      return this.data;
    },
    // reset(){
    //     // this.data = null;
    //     // this.get();
    //     console.log("agamaStore action reset")
    //     this.$reset();  // Automatically resets the store to the initial state
    // }
    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
});
